"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _router = require("./router");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var useRedirect = function useRedirect(fromURL, toURL) {
  var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var replace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var parentRouterId = _react.default.useContext(_router.ParentContext);

  var currentPath = (0, _router.getWorkingPath)(parentRouterId);

  if (currentPath === fromURL) {
    (0, _router.navigate)(parentRouterId ? ".".concat(toURL) : toURL, replace, queryParams);
  }
};

var _default = useRedirect;
exports.default = _default;